export const ALERT = 'ALERT'

export function alertDisplay() {
  return {
    type: 'ALERT'
  }
}